import { SWRConfiguration } from 'swr'

export const swrConfig: SWRConfiguration = {
  revalidateOnFocus: false, // 禁用焦点重新验证
  revalidateOnReconnect: false, // 禁用重新连接时重新验证
  shouldRetryOnError: false, // 禁用错误重试
  dedupingInterval: 5000, // 5秒内的重复请求会被去重
}
